<template>
  <div>
    <div class="sign-pad" ref="signPad">
      <canvas ref="signCanvas"
        @mousedown="startDraw"
        @mousemove="drawing"
        @mouseup="stopDraw"
        @mouseleave="stopDraw"
        @touchstart.prevent="startDraw"
        @touchmove.prevent="drawing"
        @touchend.prevent="stopDraw"
      />
    </div>
    <div slot="footer">
      <el-button type="primary" @click="onClear">清除</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDrawing: false,
      ctx: null,
      canvasWidth: 550,
      canvasHeight: 300
    }
  },
  created() {
    this.initCanvas()
  },
  methods: {
    initCanvas() {
      this.$nextTick(() => {
        const canvas = this.$refs.signCanvas
        if (!canvas) return
        canvas.width = this.canvasWidth
        canvas.height = this.canvasHeight
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.strokeStyle = '#333'
        ctx.lineWidth = 3
        ctx.lineCap = 'round'
        ctx.lineJoin = 'round'
        this.ctx = ctx
      })
    },
    getPos(e) {
      const canvas = this.$refs.signCanvas
      const rect = canvas.getBoundingClientRect()
      const touch = e.touches ? e.touches[0] : e
      const scaleX = canvas.width / rect.width
      const scaleY = canvas.height / rect.height
      return {
        x: (touch.clientX - rect.left) * scaleX,
        y: (touch.clientY - rect.top) * scaleY
      }
    },
    startDraw(e) {
      if (!this.ctx) return
      this.isDrawing = true
      const pos = this.getPos(e)
      this.ctx.beginPath()
      this.ctx.moveTo(pos.x, pos.y)
    },
    drawing(e) {
      if (!this.isDrawing || !this.ctx) return
      const pos = this.getPos(e)
      this.ctx.lineTo(pos.x, pos.y)
      this.ctx.stroke()
    },
    stopDraw() {
      this.isDrawing = false
    },
    onClear() {
      if (!this.ctx) return
      const canvas = this.$refs.signCanvas
      this.ctx.fillStyle = '#fff'
      this.ctx.fillRect(0, 0, canvas.width, canvas.height)
    },
    isEmpty() {
      const canvas = this.$refs.signCanvas
      const ctx = canvas.getContext('2d')
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data
      // 检查是否有非白色像素（即是否有签名内容）
      for (let i = 0; i < imageData.length; i += 4) {
        // 如果像素不是白色 (255,255,255)，说明有签名
        if (imageData[i] !== 255 || imageData[i + 1] !== 255 || imageData[i + 2] !== 255) {
          return false
        }
      }
      return true
    },
    onConfirm() {
      const canvas = this.$refs.signCanvas
      const base64 = canvas.toDataURL('image/png')
      this.$emit('confirm', base64)
      this.onClose()
    },
    onClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-pad {
  canvas {
    width: 100%;
    height: 300px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: crosshair;
    background: #fff;
  }
}
</style>
